export type NotificationSetting = "now" | "on" | "off" | null | undefined;

export const getNotificationMenuStatus = (
  setting: NotificationSetting,
): string => {
  switch (setting) {
    case "on":
      return "1日1回";
    case "off":
      return "オフ";
    case "now":
    default:
      return "今すぐ";
  }
};

/** 件数をメニュー表示用ラベルに変換する。未取得時は表示なし（undefined）。 */
export const getCountMenuStatus = (
  count: number | undefined,
): string | undefined => (count === undefined ? undefined : String(count));
